import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CreateLongFormFromContent(
    $projectId: ID!
    $contentType: LongFormContentTypeEnum!
    $allInstructionsData: JSON!
    $imageResourceId: ID
    $inputSections: [ImproveSectionInput!]
  ) {
    createLongFormFromContent(
      projectId: $projectId
      contentType: $contentType
      allInstructionsData: $allInstructionsData
      imageResourceId: $imageResourceId
      inputSections: $inputSections
    ) {
      id
    }
  }
`;

export const createLongFormFromContent = async ({
  projectId,
  contentType,
  allInstructionsData,
  imageResourceId,
  inputSections,
}) => {
  const variables = {
    projectId,
    contentType,
    allInstructionsData: stringifyIfPresent(allInstructionsData),
    imageResourceId,
    inputSections,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
